import React, { useState, useEffect } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { Box, Button, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ViewReturnDetailsBody from "../../components/grn/ViewReturnDetailsBody";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";
import { externalgetApi } from "../../services/externalApis";

import { GRN_API_18 } from "../../api/ApiModel";
import { useSelector } from "react-redux";

function ViewReturnDetails() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const { grncode, trsts, totalGross, taxValues, grnTaxTypes, grnreturncode, returneddate } =
    location?.state || {};

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertType, setAlertType] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");

  const [otherchargevalue, setotherchargevalue] = useState([]);

  const statusCode = location.state?.trsts;
  const origin = location.state?.origin;
  const {
    grnItems = [],

    selectedSupplier = [],
    grnDetailsForm,
    grnData = [],
    attachments = [],
    addedCharges = [],
    processResponse,
    calSummary,
    grncal,
  } = location.state || {};
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE } = SYS_USER.USER_PARAM || {};

  const [grnList, setGrnList] = useState([]);
  const [trackingDetails, setTrackingDetails] = useState([]);
  const [grnDocuments, setGrnDocuments] = useState([]);
  const [grnReturns, setGrnReturns] = useState([]);
  const [grnPaySummery, setGrPaySummery] = useState([]);
  const [grnPayTax, setGrnPayTax] = useState([]);
  const [grnReturnList, setgrnReturnList] = useState([]);
  const [grnCompany, setGrnCompany] = useState([]);
  const [grncharges, setGrnCharges] = useState([]);
  const [errorQueue, setErrorQueue] = useState([]);

  const showNextError = () => {
    setErrorQueue((prevQueue) => {
      if (prevQueue.length === 0) {
        setAlertOpen(false);
        setAlertMessage("");
        return [];
      }
      const [nextMsg, ...rest] = prevQueue;
      setAlertMessage(nextMsg);
      setAlertOpen(true);
      return rest;
    });
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setAlertOpen(false);
    // Show next error after current snackbar closes
    setTimeout(() => {
      showNextError();
    }, 200); // small delay to avoid overlap
  };
  useEffect(() => {
    if (grncode && trsts) {
      fetchGrnData(grncode, trsts, grnreturncode);
    }
  }, [grncode, trsts, grnreturncode]);

  const fetchGrnData = async (grncode, trsts, grnreturncode) => {
    try {
      const result = await externalgetApi(GRN_API_18, "GET", {
        COMPCODE,
        GRNCODE: grncode,
        RETURNCODE: grnreturncode || "",
        STS: trsts,
      });
      setGrnList(result || []);
      setTrackingDetails(result?.[0]?.tracking || []);
      setGrnReturns(result?.[0]?.returns || []);
      setGrnDocuments(result?.[0]?.documents || []);
      setGrPaySummery(result?.[0]?.grnPaySummery || []);
      setGrnPayTax(result?.[0]?.grnPayTax || []);
      setGrnCompany(result?.[0]?.company || []);
      setgrnReturnList(result?.[0]?.grnReturnMaster || []);
      setotherchargevalue(result?.[0]?.charges || []);
      console.log("result dddd", result);
    } catch (err) {
      console.error("Error fetching GRN data:", err);
      setAlertType("error");
      setAlertMessage("Failed to fetch GRN data");
      setAlertOpen(true);
    }
  };

  const productsToDisplay =
    grnList.length > 0 &&
    Array.isArray(grnList[0].products) &&
    grnList[0].products.length > 0
      ? grnList[0].products
      : grnItems || [];

  return (
    <>
      <Box
        sx={{
          mx: "auto",
          p: 2,
          background: theme.palette.background.paper,
        }}
      >
        <ViewReturnDetailsBody
          grnItems={productsToDisplay}
          selectedSupplier={selectedSupplier}
          grnDetailsForm={grnDetailsForm}
          attachments={attachments}
          statusCode={statusCode}
          grnHeader={grnList.length > 0 ? grnList[0].header : null}
          grncode={grncode}
          trackingDetails={trackingDetails}
          trsts={trsts}
          grnDocuments={grnDocuments}
          grnReturns={grnReturns}
          grnPaySummery={grnPaySummery}
          grnPayTax={grnPayTax}
          grnData={grnData}
          totalGross={totalGross}
          taxValues={taxValues}
          grnTaxTypes={grnTaxTypes}
          grnCompany={grnCompany}
          origin={origin}
          grncharges={grncharges}
          addedCharges={addedCharges}
          grnReturnList={grnReturnList}
          otherchargevalue={otherchargevalue}
          processResponse={processResponse}
          grncal={grncal}
          calSummary={calSummary}
          grnreturncode ={grnreturncode}
          returneddate={returneddate}
        />

        <Divider />

        <Box
          my={2}
          pb={2}
          gap={2}
          width={"100%"}
          display={"flex"}
          justifyContent={"flex-end"}
        >
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            sx={{ ...styles.btn_secondary }}
            // onClick={goToBack}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>

        <SystemAlert
          alertOpen={alertOpen}
          alertType={alertType}
          alertMessage={alertMessage}
          handleSnackbarClose={handleSnackbarClose}
        />
      </Box>
    </>
  );
}

export default ViewReturnDetails;
